<div class="border p-3 rounded shadow-sm">
  <div class="row g-2 align-items-center">
    <!-- Left Info -->
    <div class="col-lg-5">
      <div class="row">
        <div class="col-6">
          <p class="mb-1"><strong>{{ 'Vendor ID' | wordReplace }}</strong> : {{vendorMarketID}}</p>
          <p class="mb-1"><strong>Name</strong> : {{vendorName}}</p>
        </div>
        <div class="col-6">
          <p class="mb-1"><strong>Telephone</strong> : {{telephone | phoneFormat}}</p>
          <p class="mb-1"><strong>Email</strong> : {{Email}}</p>
        </div>
      </div>
    </div>

    <div class="col-lg-7 d-flex align-items-center gap-2">
      <div>
        <label class="form-label mb-0"><strong>From</strong></label>
        <ejs-datepicker class="form-control p-0" [(ngModel)]="fromDate" (ngModelChange)="onFromDateChange()"
          [max]="maxExpiryDate"></ejs-datepicker>
      </div>
      <div>
        <label class="form-label mb-0"><strong>To</strong></label>
        <ejs-datepicker class="form-control p-0" [(ngModel)]="toDate" (ngModelChange)="onToDateChange()"
          [max]="maxExpiryDate" [min]="fromDate"></ejs-datepicker>
      </div>
      <div class="form-check ms-3 mt-3">
        <button class="btn btnAS" (click)="addVendorNote()">NEW</button>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12 text-start mt-2">
    <ejs-grid #gridNotes [dataSource]="NotesData" [height]="300" (rowSelected)="onRowSelected($event)">
      <e-columns>
        <e-column field="NotesDateTime" headerText="Notes Date & Time" type="date" format="MM/dd/yyyy hh:mm a"
          width="150"></e-column>
        <e-column field="EnteredBy" headerText="Entered by" width="170"></e-column>
        <e-column field="Notes" headerText="Notes" width="250"></e-column>
        <e-column field="Remove" headerText="Remove" width="100" textAlign="Center">
          <ng-template #template let-data>
            <a (click)="deleteVendorNote(data.VendorNotesId); $event.stopPropagation()">
              <img src="./assets/images/delete.svg" class="img-fluid" />
            </a>
          </ng-template>
        </e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>
<!-- Modal -->
<div class="modal fade" id="vendorNoteModal" tabindex="-1" aria-labelledby="vendorNoteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <form class="modal-content" [formGroup]="vendorNoteForm">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="vendorNoteModalLabel">Add Notes</h1>
        <button type="button" class="btn-close" (click)="closeModalById('vendorNoteModal')"></button>
      </div>
      <div class="modal-body">
        <div class="border p-3 rounded shadow-sm">
          <div class="row g-2 align-items-center">
            <div class="col-lg-8">
              <div class="row">
                <div class="col-6">
                  <p class="mb-1"><strong>{{ 'Vendor ID' | wordReplace }}</strong> : {{vendorMarketID}}</p>
                  <p class="mb-1"><strong>Name</strong> : {{vendorName}}</p>
                </div>
                <div class="col-6">
                  <p class="mb-1"><strong>Phone</strong> : {{telephone | phoneFormat}}</p>
                  <p class="mb-1"><strong>Email</strong> : {{Email}}</p>
                </div>
              </div>
            </div>
            <div class="col-lg-4 gap-2">
              <div class="row">
                <div class="col-12">
                  <p class="mb-1"><strong>Address</strong> : {{address}}</p>
                  <p class="mb-1"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-start mt-2">
            <textarea class="form-control" formControlName="Notes" placeholder="Note" maxlength="200"
              style="height: 250px"></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btnAS" (click)="saveVendorNote()">Save</button>
        <button type="button" class="btn btn-orange" (click)="closeModalById('vendorNoteModal')">Cancel</button>
      </div>
    </form>
  </div>
</div>